// The API returns one flat row per Contact-Lead link (or one row with null lead
// columns for a contact with no active links). This collapses those flat rows into
// one row per contact, collecting all of its leads. spSearchContacts paginates on
// distinct contacts, so every flat row for one contact arrives together in one page.
// Order of first appearance is preserved (the SP already applies the sort).
export function groupRowsByContact(rows) {
    const order = [];
    const map = new Map();
    for (const row of rows) {
        let group = map.get(row.contactId);
        if (!group) {
            group = {
                contactId: row.contactId,
                name: row.name,
                function: row.function,
                email: row.email,
                phoneNumber: row.phoneNumber,
                leads: [],
                totalRows: row.totalRows,
            };
            map.set(row.contactId, group);
            order.push(row.contactId);
        }
        if (row.leadId && row.leadContactId && row.leadNumber != null) {
            group.leads.push({
                leadContactId: row.leadContactId,
                leadId: row.leadId,
                leadNumber: row.leadNumber,
                leadStatus: row.leadStatus,
                companyId: row.companyId,
                companyName: row.companyName,
            });
        }
    }
    return order.map((id) => map.get(id));
}
